module.exports = __webpack_public_path__ + "static/media/calender.44e111e3.svg";